import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  label?: string;
  href?: string;
  size?: 'md' | 'lg';
};
export function CtaButton({
  label = 'Quiero empezar ahora',
  href = '#comprar',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-lg sm:text-xl' : 'px-6 py-3.5 text-base';
  return <a href={href} className={`group inline-flex items-center justify-center gap-3 whitespace-nowrap rounded-full bg-lime font-display font-extrabold uppercase tracking-wide text-ink transition-[transform,background-color] duration-150 ease-out hover:bg-[#3cf07f] active:scale-[0.97] focus:outline-none focus-visible:ring-4 focus-visible:ring-lime/40 ${sizing}`} data-id="element-53" data-mp="cjhica1yxoli">
      {label}
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-54" data-mp="vbse7jy7gma4" />
    </a>;
}